import React from "react";
import "./index.css";
import App from "./App";
import common_it from "./translations/it/common.json";
import common_en from "./translations/en/common.json";
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { Provider } from "react-redux";
import store from "./store";
import { routerBasename } from './router/basePath';

const lan = localStorage.getItem("language") || "en";
i18next.init({
  fallbackLng: "en",
  interpolation: { escapeValue: false },
  lng: lan,
  resources: {
    en: { common: common_en },
    it: { common: common_it },
  },
});

/**
 * GameApp – the full game UI with all providers (router, redux, i18n, etc.).
 * Used when the user is logged in via the outer SSO app.
 */
function GameApp() {
  return (
      <I18nextProvider i18n={i18next}>
        <BrowserRouter basename={routerBasename(window.location.pathname)}>
          <Provider store={store}>
            <Toaster position="bottom-right" />
            <App />
          </Provider>
        </BrowserRouter>
      </I18nextProvider>
  );
}

export default GameApp;
